var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{class:_vm.baseClass,attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{staticStyle:{"margin-bottom":"8px","margin-top":"8px"},attrs:{"size":75,"color":"teal","width":8,"value":_vm.value}},[_vm._v(" "+_vm._s(_vm.value)+"% ")]),_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v(" "+_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }